import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 text-lg font-medium leading-6 text-gray-900" }
const _hoisted_2 = { class: "truncate text-gray-400" }
const _hoisted_3 = { class: "sm:pt-4 pt-2 sm:border-t sm:border-gray-200" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 2,
  class: "pt-4"
}
const _hoisted_7 = ["disabled"]

import { MinusIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";
import Modal from "shared/components/modals/Modal.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { User } from "shared/types/User";
import {
  useDeleteUser,
  useUpdateUserOrganizationPermission,
  useUpdateUserProjectPermission,
} from "@/composables/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveUserModal',
  props: {
    user: {},
    organizationId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const customerName = useCurrentCustomerName();
const siteId = useCurrentSiteId();
const { updateUserProjectPermission, isUpdateLoading: isUpdateUserProjectPermissionLoading } =
  useUpdateUserProjectPermission();
const {
  updateUserOrganizationPermission,
  isUpdateLoading: isUpdateUserOrganizationPermissionLoading,
} = useUpdateUserOrganizationPermission();
const { deleteUser, isLoading: isDeleteUserLoading } = useDeleteUser();

const handleRemoveUserFromProjectClick = async () => {
  const currentProjectPermission = props.user.projects.find(
    (project) => project.customer_name === customerName && project.site_id === siteId,
  );
  if (currentProjectPermission) {
    await updateUserProjectPermission({
      username: props.user.username,
      updatedProjectPermission: {
        ...currentProjectPermission,
        explicit_groups: [],
        groups: [],
      },
    })
      .then(() => {
        emit("close");
      })
      .catch(() => undefined);
  } else {
    emit("close");
  }
};

const handleRemoveUserFromOrganizationClick = async () => {
  if (!props.organizationId) {
    return;
  }
  await updateUserOrganizationPermission({
    username: props.user.username,
    organizationId: props.organizationId,
    organizationPermission: { explicit_groups: [], company_type: null },
  })
    .then(() => {
      emit("close");
    })
    .catch(() => undefined);
};

const handleDeleteUserPermanentlyClick = async () => {
  await deleteUser(props.user.username)
    .then(() => {
      emit("close");
    })
    .catch(() => undefined);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: true,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
    "custom-cls": "sm:w-full sm:max-w-lg"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.user.name), 1),
        _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.user.email), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.organizationId)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              disabled: _unref(isUpdateUserProjectPermissionLoading),
              class: "inline-flex items-center w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 sm:col-start-1 sm:mt-0 sm:text-sm",
              onClick: handleRemoveUserFromProjectClick
            }, [
              _createVNode(_unref(MinusIcon), {
                class: "-ml-1 mr-3 h-5 w-5",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("admin.project_participants.modal_delete_user.delete_from_project")), 1)
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.organizationId)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              disabled: _unref(isUpdateUserOrganizationPermissionLoading),
              class: "inline-flex items-center w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 sm:col-start-1 sm:mt-0 sm:text-sm",
              onClick: handleRemoveUserFromOrganizationClick
            }, [
              _createVNode(_unref(MinusIcon), {
                class: "-ml-1 mr-3 h-5 w-5",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("admin.project_participants.modal_delete_user.delete_from_organization")), 1)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.hasPermission('app_admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                disabled: _unref(isDeleteUserLoading),
                class: "inline-flex items-center w-full justify-center rounded-md border border-transparent bg-red-500 px-4 py-2 text-xs sm:text-base font-medium text-white shadow-sm hover:bg-red-600 sm:col-start-2 sm:text-sm",
                onClick: handleDeleteUserPermanentlyClick
              }, [
                _createVNode(_unref(XMarkIcon), {
                  class: "-ml-1 mr-3 h-5 w-5",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("admin.project_participants.modal_delete_user.delete_permanently")), 1)
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})